import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { Fetch } from "../../shared/Fetch";
import { ILogin } from "../../models/Login";
import { Toast } from "primereact/toast";

interface IProps {
    open: boolean,
    login_ID: number,
    singleData: any[],
    userData: any,
    setModal: (e: any) => void,
    LoadSavedTeams: () => void,
}

export const MoveTeamsFormMH = (props: IProps) => {
    const [selectMoveTeams, setSelectMoveTeams] = useState<Array<any>>([]);
    const [load, setLoad] = useState(false);
    const toast = useRef<any>(null);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');

    const OnHide = () => {
        setSelectMoveTeams([]);
        props.setModal({ singleData: [], open: false });
    }

    const OnRemove = async () => {
        setLoad(true);
        const teamMembers: number[] = selectMoveTeams.map(e => e.team_ID);
        const response = await Fetch("Resource_Management_Team/removeTeamList", "DELETE", null, `Login_Id=${props.login_ID}&team_IDs=${`[${teamMembers.join(",")}]`}`, null);
        if (response) {
            toast.current.show({ severity: 'success', detail: "Team Removed", life: 3000 });
            SaveToDB();
        } else {
            toast.current.show({ severity: 'error', detail: "Few Teams are removed", life: 3000 });
            setLoad(false);
        }
    }
    const SaveToDB = async () => {
        const response = await Fetch("Resource_Management_Team/addSkillTeams", "POST", selectMoveTeams.map(e => e.team_ID), `Login_Id=${props.login_ID}`, null);
        if (response) {
            const data: any = await response.json();
            if (data.length === 0) toast.current.show({ severity: 'success', detail: "Teams are added", life: 3000 });
            if (data.length > 0) {
                toast.current.show({ severity: 'success', detail: "Few Teams are added and Some Not", life: 3000 });
            };
            props.LoadSavedTeams();
            props.setModal({ singleData: [], open: false });
            setLoad(false);
        } else {
            toast.current.show({ severity: 'error', detail: "Teams Can Not Added", life: 3000 });
            setLoad(false);
        }
    }

    useEffect(() => {
        // if(props.open) console.log(props.singleData);
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="These teams already exist to another Module Head" modal className="p-fluid" onHide={OnHide} >
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "10px" }}
                size="small"
                value={props.singleData} lazy dataKey="team_ID"
                emptyMessage="No Users found."
                header={""}
                selection={selectMoveTeams} onSelectionChange={(e) => setSelectMoveTeams(e.value)}
                loading={false}
            >
                <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                <Column field="teamName" header="Team Name" />
                <Column field="managerName" header="Module Head Name" />
            </DataTable>
            <div className="flex flex-row-reverse">
                <Button className="w-5rem h-2rem mt-3" loading={load} onClick={OnRemove}>MOVE</Button>
            </div>
            <Toast ref={toast} />
        </Dialog>
    );
}